'use strict';

require('./ContactUtilityService');
require('./HandRaiseService');
require('./RoomService');
var log = require('../../log/Log').channel('CallParticipantsController');
var defaults = require('../../defaults/Defaults');

angular.module('inara')
.directive('aveoCallParticipants', function() {
    // Directive defining a list of call participants and actions.
    return {
        restrict: 'E',
        templateUrl: 'callParticipants.html',
        scope: {
            call: '='
        },
        controller: 'CallParticipantsController',
        controllerAs: 'vm'
    };
})

.controller('CallParticipantsController', CallParticipantsController);

CallParticipantsController.$inject = ['$scope', '$timeout', '$window', '$state', 
                                      '$ionicPopover', '$ionicPosition', 
                                      '$ionicViewSwitcher', 'ionicMaterialInk', 
                                      '$document', '$q', 'ContactUtilityService',
                                      'RoomService', 'gettextCatalog', 'HandRaiseService',
                                      '$ionicScrollDelegate'];

function CallParticipantsController($scope, $timeout, $window, $state,
                                    $ionicPopover, $ionicPosition, 
                                    $ionicViewSwitcher, ionicMaterialInk, 
                                    $document, $q, ContactUtilityService,
                                    RoomService, gettextCatalog, HandRaiseService,
                                    $ionicScrollDelegate) {
    var vm = this;
    var callParticipantsItemWidth = '';
    var callParticipantsItemHeight = '';
    var participantControls = null;
    var participants = null;
    var participantsInitialized = false;
    var participantStyles = {};
    var participantsTimeout = null;

    log.info('initializing');

    vm.getAudioStatusClasses = getAudioStatusClasses;
    vm.getContactPictureStyle = getContactPictureStyle;
    vm.getContactInitials = ContactUtilityService.getContactInitials;
    vm.getParticipantName = getParticipantName;
    vm.getParticipantIdentifiers = getParticipantIdentifiers;
    vm.getParticipantItemWidth = function() { return callParticipantsItemWidth; };
    vm.getParticipantItemHeight = function() { return callParticipantsItemHeight; };
    vm.getParticipants = getParticipants;
    vm.getVideoStatusClasses = getVideoStatusClasses;
    vm.handRaisedFlash = handRaisedFlash;
    vm.handRaisedHighlight = handRaisedHighlight;
    vm.hasAudio = hasAudio;
    vm.hasVideo = hasVideo;
    vm.hasParticipantIdentifiers = hasParticipantIdentifiers;
    vm.isHandRaised = isHandRaised;
    vm.isHost = isHost;
    vm.isSelected = isSelected;
    vm.muteAll = muteAll;
    vm.orderCohost = orderCohost;
    vm.orderHandRaised = orderHandRaised;
    vm.orderHandRaisedTimestamp = orderHandRaisedTimestamp;
    vm.orderHost = orderHost;
    vm.orderMe = orderMe;
    vm.participantLayoutReady = false;
    vm.showParticipantControls = showParticipantControls;

    ionicMaterialInk.displayEffect({ duration: defaults.inara.inkDuration });

    $scope.$on('IdleTimeout', function() {
        hideParticipantControls();
    });

    $scope.$on('$destroy', function() {
        hideParticipantControls();
    });

    $scope.$on('popover.hidden', function($event, popover) {
        if (popover === participantControls) {
            popover.remove();
        }
    });

    $scope.$on('popover.removed', function($event, popover) {
        if (popover === participantControls) {
            $scope.selectedParticipant = null;
            participantControls = null;
        }
    });

    $scope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
        if (toState.name !=='control.calls') hideParticipantControls();
    });

    // Message getters for participant controls popover
    $scope.getMuteMsg = function(participant) {
        if (participant === null || !angular.isDefined(participant)) return '';
        /// Button label for call participant mute
        return participant.audioMuted ?
            gettextCatalog.getString('Ask to Unmute') : gettextCatalog.getString('Mute');
    };

    $scope.getVideoMsg = function(participant) {
        if (participant === null || !angular.isDefined(participant)) return '';
        /// Button label for call participant video
        return participant.sendingVideo ?
            gettextCatalog.getString('Stop Video') : gettextCatalog.getString('Ask to Start Video');
    };

    // Button handlers for participant controls popover
    $scope.onClickParticipantOption = function() {
        hideParticipantControls();
    };

    $scope.onToggleMute = function(participant) {
        $scope.call.$setParticipantAudioMute(participant.$id, !participant.audioMuted);
        hideParticipantControls();
    };

    $scope.onToggleVideo = function(participant) {
        $scope.call.$setParticipantVideoMute(participant.$id, participant.sendingVideo);
        hideParticipantControls();
    };

    function getAudioStatusClasses(call, participant) {
        var audioMuted = participant.isMe ?
            RoomService.online() && RoomService.getRoom().states.mute :
            participant.audioMuted;
        return audioMuted ? 'ion-aveo-microphone-off muted' : 'ion-android-microphone';
    }

    function getContactPictureStyle(participant) {
        var uniqueId;

        if ('userId' in participant) {
            uniqueId = participant.userId;
        } else if ('displayName' in participant) {
            uniqueId = participant.displayName;
        } else {
            log.error('can\'t cache picture style without unique id');
            return '';
        }

        if (!angular.isDefined(participantStyles[uniqueId])) {
            participantStyles[uniqueId] =
                ContactUtilityService.getContactPictureStyle(participant);
        }
        return participantStyles[uniqueId];
    }

    function getParticipantIdentifiers(participant) {
        var id = '(';
        if (participant.isHost) {
            /// Role identifier label for meeting participant
            id += gettextCatalog.getString('Host');
        }
        if (participant.isMe) {
            if (id.length > 1) {
                id += ', ';
            }
            /// Role identifier label for meeting participant
            id += gettextCatalog.getString('Me');
        }
        id += ')';
        return id;
    }

    function getParticipantName(participant) {
        return participant ? participant.displayName : '';
    }

    function getParticipants(call) {
        participants = call.$getParticipants();

        if (!participantsInitialized) {
            participantsInitialized = true;
            if (participantsTimeout !== null) {
                $timeout.cancel(participantsTimeout);
                participantsTimeout = null;
            }
            participantsTimeout = $timeout(updateParticipantItemSize, 400);
        }

        return participants;
    }

    function getVideoStatusClasses(call, participant) {
        var sendingVideo = participant.isMe ? call.sendingVideo : participant.sendingVideo;
        return sendingVideo ? 'ion-aveo-camera-started' : 'ion-aveo-camera-stopped muted';
    }

    function handRaisedFlash(call, participant) {
        return call &&
            participant &&
            HandRaiseService.participantFlashState(call.$id, participant.$id);
    }

    function handRaisedHighlight(call, participant) {
        return call &&
            participant &&
            HandRaiseService.participantHighlightState(call.$id, participant.$id);
    }

    function hasAudio(participant) {
        return participant.hasAudioMute === true;
    }

    function hasParticipantIdentifiers(participant) {
        return participant && (participant.isHost || participant.isMe);
    }

    function hasVideo(participant) {
        return participant.hasVideoMute === true;
    }

    function hideParticipantControls() {
        if (participantControls !== null) return participantControls.remove();
        return $q.resolve();
    }

    function isHandRaised(participant) {
        return participant && participant.isHandRaised === true;
    }

    function isHost() {
        if (participants !== null) {
            for (var i = 0; i < participants.length; i++) {
                if (participants[i].isMe && participants[i].isHost) return true;
            }            
        }
        return false;
    }

    function isSelected(participant) {
        return participant &&
            $scope.selectedParticipant &&
            participant.$id === $scope.selectedParticipant.$id;
    }

    function muteAll(call, mute) {
        // set UI state first to improve responsiveness
        for (var i = 0; i < participants.length; i++) {
            participants[i].audioMuted = mute;
        }
        call.$setParticipantAudioMute('*', mute);
    }

    function orderCohost(participant) {
        return participant && participant.isCohost !== true;
    }

    function orderHandRaised(participant) {
        return participant && participant.isHandRaised !== true;
    }

    function orderHandRaisedTimestamp(participant) {
        return participant && participant.isHandRaised === true && $scope.call ?
            HandRaiseService.participantHandRaiseTimestamp($scope.call.$id, participant.$id) : 0;
    }

    function orderHost(participant) {
        return participant && participant.isHost !== true;
    }

    function orderMe(participant) {
        return participant && participant.isMe !== true;
    }

    function positionParticipantPopoverView(target, popoverEle) {
        // Adapted from $ionicPopover source
        var targetEle = angular.element(target.target || target);
        var buttonOffset = $ionicPosition.offset(targetEle);
        var popoverWidth = popoverEle.prop('offsetWidth');
        var popoverHeight = popoverEle.prop('offsetHeight');
        // Use innerWidth because clientWidth doesn't work consistently for 
        // body on all platforms
        var bodyWidth = $window.innerWidth;

        var popoverCSS = {
            left: buttonOffset.left
        };
        var arrowEle = angular.element(popoverEle[0].querySelector('.popover-arrow'));

        if (popoverCSS.left < 0) {
            popoverCSS.left = 0;
        } else if (buttonOffset.left + buttonOffset.width + popoverWidth > bodyWidth) {
            popoverCSS.left = bodyWidth - popoverWidth - buttonOffset.left;
        }

        popoverCSS.top = buttonOffset.top + buttonOffset.height - popoverHeight;

        arrowEle.css({
            left: - arrowEle.prop('offsetWidth') + 'px',
            bottom: arrowEle.prop('offsetHeight') + 'px'
        });

        popoverEle.css({
            top: popoverCSS.top + 'px',
            left: popoverCSS.left + 'px',
            marginLeft: '0',
            opacity: '1'
        });
    }

    function showParticipantControls(call, participant, $event) {
        // ZOOM TODO: checking isHost() assumes that no participant controls are 
        // available to non-hosts. When we add support for pinning video or other
        // non-host functions, we should stop checking this.
        if (participant.isMe || !isHost()) return $q.resolve();

        return hideParticipantControls().then(function() {
            $scope.selectedParticipant = participant;
            return $ionicPopover.fromTemplateUrl('callParticipantControls.html', {
                scope: $scope,
                positionView: positionParticipantPopoverView
            }).then(function(popover) {
                participantControls = popover;
                return participantControls.show($event);
            });
        });
    }

    function updateParticipantItemSize() {
        if (participants.length === 0) {
            // No participants loaded yet - reschedule this update
            participantsTimeout = $timeout(updateParticipantItemSize, 400);
            return;
        }
        // After view renders, get the participant item size so we can inform
        // collection-repeat on the participant items of their actual size.
        var item = $document[0].querySelectorAll(
            '#call-participants .collection-repeat-container > .item:first-child');
        var style = item.length > 0 ? $window.getComputedStyle(item[0]) : null;
        callParticipantsItemWidth = style !== null ? style.width : '';
        callParticipantsItemHeight = style !== null ? style.height : '';
        // This flag ensures we only show the participants after the view has
        // rendered and the item size has been determined.
        vm.participantLayoutReady = true;
        // this triggers a size recalculation for the collection-repeat items
        if ($state.current.name !== 'control.calls') return;
        $ionicScrollDelegate.$getByHandle('call-participants-scroll').resize();        
    }
}

module.exports = CallParticipantsController;
